var _rect, _path, _path2, _rect2, _rect3, _rect4, _path3, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 12,
    fill: "#B9B9B9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-6615 -997C-6615 -998.105 -6614.1 -999 -6613 -999H1664C1665.1 -999 1666 -998.105 1666 -997V4767C1666 4768.1 1665.1 4769 1664 4769H-6613C-6614.1 4769 -6615 4768.1 -6615 4767V-997Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-6613 -999V-998H1664V-999V-1000H-6613V-999ZM1666 -997H1665V4767H1666H1667V-997H1666ZM1664 4769V4768H-6613V4769V4770H1664V4769ZM-6615 4767H-6614V-997H-6615H-6616V4767H-6615ZM-6613 4769V4768C-6613.55 4768 -6614 4767.55 -6614 4767H-6615H-6616C-6616 4768.66 -6614.66 4770 -6613 4770V4769ZM1666 4767H1665C1665 4767.55 1664.55 4768 1664 4768V4769V4770C1665.66 4770 1667 4768.66 1667 4767H1666ZM1664 -999V-998C1664.55 -998 1665 -997.552 1665 -997H1666H1667C1667 -998.657 1665.66 -1000 1664 -1000V-999ZM-6613 -999V-1000C-6614.66 -1000 -6616 -998.657 -6616 -997H-6615H-6614C-6614 -997.552 -6613.55 -998 -6613 -998V-999Z",
    fill: "black",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-277 -753)",
    fill: "#202020"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -153,
    y: -110,
    width: 770,
    height: 224,
    rx: 20,
    fill: "#262626"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 32,
    transform: "translate(-13.5 -10)",
    fill: "#626263"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16667 1L13.1667 6M13.1667 6L8.16667 11M13.1667 6H1.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 16.25,
    y1: -3.27835e-8,
    x2: 16.25,
    y2: 12,
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTab);
export default __webpack_public_path__ + "static/media/tab.88e43749888bebb5fee174a5a27e5831.svg";
export { ForwardRef as ReactComponent };